var _componentUiSlider = function($context) {
    if (!$().slider) {
        console.warn('Warning - jQuery UI components are not loaded.');
        return;
    }

    // Basic slider with input
    ($context instanceof jQuery ? $context.find('.js-jui-slider') : $('.js-jui-slider')).each(function() {
        var $me = $(this);
        
        $me.data('input', $('#' + $me.data('input')));
        $me.slider({
            isRTL: $('html').attr('dir') == 'rtl' ? true : false,
            range: 'min',
            value: $me.data('input').val(),
            min: 0,
            max: 100,
            slide: function (event, ui) {
                $me.data('input').val(ui.value);
            }
        });
    });
};

function init($context) {
    _componentUiSlider($context);
}

export const JqueryUiSliders = {
    init
}